import React from 'react';

import { IconSearch16 } from '@dhis2/ui-icons';

const HeaderSearchControl = (props) => (
  <span class="header-action-wrap">
    <IconSearch16 color="var(-colors-grey600)" />
  </span>
);

export default HeaderSearchControl;
